import { formatMeters } from "../../ExportExcelButtonV3/utils";
import { sumElementMultipliers } from "../sumElementMultipliers";
import type { ExportSelectionItem } from "../../ExportSelectionModal/types";
import type { BuildExportSelectionInputs } from "./types";

export const buildExportSelectionInputs: BuildExportSelectionInputs = ({
  isCablesView,
  isAllElementsMode,
  groupIds,
  byGroupId,
  selectedGroupLabel,
  iconByGroupId,
  isAllRoutesMode,
  routeGroups,
  selectedRouteGroupLabel,
}) => {
  if (isCablesView) {
    const items: ExportSelectionItem[] = routeGroups.map((group) => ({
      label: group.label,
      value: formatMeters(group.meters),
      rgb: group.rgb,
    }));
    const initialSelectedLabels = isAllRoutesMode
      ? routeGroups.map((group) => group.label)
      : selectedRouteGroupLabel &&
          routeGroups.some((group) => group.label === selectedRouteGroupLabel)
        ? [selectedRouteGroupLabel]
        : [];
    return { items, initialSelectedLabels };
  }

  const items: ExportSelectionItem[] = groupIds.flatMap<ExportSelectionItem>(
    (label) => {
      const elements = byGroupId[label] ?? [];
      if (elements.length === 0) return [];
      return [
        {
          label,
          value: String(sumElementMultipliers({ elements })),
          rgb: elements[0].rgb,
          iconDataUrl: iconByGroupId.get(label) ?? "",
        },
      ];
    },
  );
  const initialSelectedLabels = isAllElementsMode
    ? groupIds.filter((label) => (byGroupId[label]?.length ?? 0) > 0)
    : selectedGroupLabel && (byGroupId[selectedGroupLabel]?.length ?? 0) > 0
      ? [selectedGroupLabel]
      : [];
  return { items, initialSelectedLabels };
};
